@if (authenticationApiService.authenticationComplete$ | async) {
    @if (authenticationApiService.loggedIn$ | async) {
        <warema-dashboard-private />
    } @else {
        <warema-dashboard-public />
    }
} @else {
    <warema-spinner [diameter]="100" />
}
